//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';

export default {
  name: 'SubscribePromoReady',
  props: {
    subscribePlanLink: {
      type: String,
      required: true,
    },
  },
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
    SubscribePromoButton: () => import('./SubscribePromoButton.vue'),
  },
  data() {
    return {
      faArrowRight,
      imageBaseUrl: 'https://static.moele.me/img/channels2022/subscription/are-you-ready.png?auto=format&w=324',
      imageBaseUrlMobile: 'https://static.moele.me/img/channels2022/subscription/are-you-ready-m.png?auto=format&w=242',
    };
  },
  computed: {
    ...mapState({
      subscriptions: state => state.user.member.subscriptions,
    }),
    ...mapGetters({
      getPlanBilledYearly: 'subscription/getPlanBilledYearly',
    }),
    hasSimilarSubscription() {
      return _.get(this.getPlanBilledYearly, 'unlimited') && this.subscriptions?.includes('unlimited');
    },
  },
};
